import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	modalContainer: {
		maxHeight: '75vh',
		minHeight: '60vh',
		overflowY: 'auto',
	},
});
